import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import {loader as escalationDetailsLoader} from '../../components/Escalation/components/EscalationForm';
import { QueryClient } from '@tanstack/react-query';

const UserListPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserListPage')
);
const UserCreatePage = withLazyLoading(
  () => import('../../pages/user-management/components/UserCreatePage')
);
const UserInvitePage = withLazyLoading(
  () => import('../../pages/user-management/components/UserInvitePage')
);
const UserEditPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserEditPage')
);
const RoleListPage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleListPage')
);
const RoleCreatePage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleCreatePage')
);
const RoleEditPage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleEditPage')
);
const PermissionList = withLazyLoading(
  () => import('../../pages/user-management/permissions/permissionList')
);
const GroupListPage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupListPage')
);
const GroupCreatePage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupCreatePage')
);
const GroupEditPage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupEditPage')
);
const DigitalPaaniTeam = withLazyLoading(
  () => import('../../pages/digitalPaaniTeam')
);
const EscalationList = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationList')
);
const EscalationFormWrapper = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationForm')
);

const CommunicationModule = withLazyLoading(
  () => import ('../../components/CommunicationModule/components/CommunicationModuleView')
)

const userRoutes =  (queryClient: QueryClient) => [
  {
    path: '/userGroupList',
    handle: createCrumbHandle('User Groups'),
    children: [
      {
        index: true,
        element: <GroupListPage />,
        // authz-v2 TODO: Group_View_R — gate server-side / useCan at component level
      },
      {
        path: 'editUserGroup/:id',
        element: <GroupEditPage />,
        // authz-v2 TODO: Group_Configuration_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Edit User Group'),
      },
      {
        path: 'createUserGroup',
        element: <GroupCreatePage />,
        // authz-v2 TODO: Group_Manage_A — gate server-side / useCan at component level
        handle: createCrumbHandle('Create User Group'),
      },
    ]
  },
  {
    path: '/userList',
    handle: createCrumbHandle('Users'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<UserListPage />),
        // authz-v2 TODO: UserList_View_R — gate server-side / useCan at component level
      },
      {
        path: 'editUser/:id',
        element: withPostHogTracker(<UserEditPage />),
        // authz-v2 TODO: Add-EditUser_Configuration_AE — gate server-side / useCan at component level
        handle: createCrumbHandle('Edit User'),
      },
      {
        path: 'createUser',
        element: withPostHogTracker(<UserCreatePage />),
        // authz-v2 TODO: Add-EditUser_Configuration_AE — gate server-side / useCan at component level
        handle: createCrumbHandle('Create User'),
      },
      {
        path: 'inviteUser/:invitedUserId?',
        element: withPostHogTracker(<UserInvitePage />),
        // authz-v2 TODO: Add-EditUser_Configuration_AE — gate server-side / useCan at component level
        handle: createCrumbHandle('Invite User'),
      },
    ]
  },
  {
    path: '/rolelist',
    handle: createCrumbHandle('Roles'),
    children: [
      {
        index: true,
        element: <RoleListPage />,
        // authz-v2 TODO: RoleList_View_R — gate server-side / useCan at component level
      },
      {
        path: 'editRole/:id',
        element: <RoleEditPage />,
        // authz-v2 TODO: GroupRole_Manage_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Edit Role'),
      },
      {
        path: 'createrole',
        element: <RoleCreatePage />,
        // authz-v2 TODO: GroupRole_Manage_WE — gate server-side / useCan at component level
        handle: createCrumbHandle('Create Role'),
      },
    ]
  },
  {
    path: '/escalation',
    handle: createCrumbHandle('Escalation'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<EscalationList />),
      },
      {
        path: 'create',
        element: withPostHogTracker(<EscalationFormWrapper />),
        handle: createCrumbHandle('Create Escalation'),
      },
      {
        path: ':escalationId',
        element: withPostHogTracker(<EscalationFormWrapper />),
        loader: escalationDetailsLoader(queryClient),
        handle: createCrumbHandle('Edit Escalation'),
      },
    ]
  },
  {
    path: '/permission',
    element: <PermissionList />,
    // authz-v2 TODO: PermissionsList_View_R — gate server-side / useCan at component level
    handle: createCrumbHandle('Permissions'),
  },
  {
    path: '/digitalPaaniTeam',
    element: <DigitalPaaniTeam />,
    handle: createCrumbHandle('Digital Paani Team'),
  },
  {
    path: '/communication',
    element: withPostHogTracker(<CommunicationModule />),
    handle: createCrumbHandle('Communication')
  }
];

export default userRoutes;
